// IMPORTANT: Note that with Redux, state should NEVER be changed.
import objectAssign from 'object-assign';
import initialState from '../store/initialState';
import { clone } from './helper';
import {
  GET_GROUPS,
  GOT_GROUPS,
  ERROR_GETTING_GROUPS,
  GET_GROUP_DETAILS,
  GOT_GROUP_DETAILS,
  UPDATE_GROUP_FORM,
  RESET_GROUP_FORM,
  CLICKED_NEW_GROUP,
  UPDATE_GROUP,
  UPDATED_GROUP,
  CLICKED_UPDATE_GROUP,
  UPDATE_GROUP_SEARCH,
  DELETE_GROUP,
  DELETED_GROUP,
  RESET_GROUP,
  CREATE_GROUP,
  CREATED_GROUP,
  GET_GROUPS_WITH_PERMISSION,
  GOT_GROUPS_WITH_CREATE_PERMISSION,
  RESET_SAVING_FLAG,
} from '../actions/group.js';

const reducer = (state = initialState, action, cleanGroupForm = initialState.cleanGroupForm) => {
  switch (action.type) {
    case GET_GROUPS:
      return objectAssign({}, state, { fetchingGroups: true });
    case GOT_GROUPS:
      return objectAssign({}, state, {
        groups: action.data,
        fetchingGroups: false,
      });

    case GET_GROUPS_WITH_PERMISSION:
      return objectAssign({}, state, { fetchingGroupsWithPermission: true });

    case GOT_GROUPS_WITH_CREATE_PERMISSION:
      return objectAssign({}, state, {
        meetingRoomGroups: action.data,
        fetchingGroupsWithPermission: false,
      });

    case CREATE_GROUP:
      var copy = clone(state);
      copy.groupForm.saving = true;
      return objectAssign({}, state, { groupForm: copy.groupForm });
    case CREATED_GROUP:
      action.data.saving = false;
      return objectAssign({}, state, {
        fetching: false,
        groupForm: action.data,
        groups: [action.data].concat(state.groups),
      });
    case RESET_SAVING_FLAG:
      var copy = clone(state);
      copy.groupForm.saving = false;
      return objectAssign({}, state, { groupForm: copy.groupForm });
    case UPDATE_GROUP_FORM:
      action.data.edittedByChild = true;
      return objectAssign({}, state, { groupForm: action.data });

    case UPDATE_GROUP:
      var copy = clone(state);
      copy.groupForm.saving = true;
      return objectAssign({}, state, { groupForm: copy.groupForm });
    case UPDATED_GROUP:
      var copy = clone(state);
      var index = copy.groups.findIndex((x) => x.id == action.data.id);
      if (index >= 0) {
        copy.groups[index] = action.data;
      }
      copy.groupForm.saving = false;

      return copy;

    case DELETE_GROUP:
      var copy = clone(state.groupForm);
      copy.saving = true;
      return objectAssign({}, state, { groupForm: copy });
    case DELETED_GROUP:
      return objectAssign({}, state, {
        groups: state.groups.filter((p) => p.id !== action.data.id),
        fetchingGroups: false,
      });
    case RESET_GROUP_FORM:
      return objectAssign({}, state, { groupForm: cleanGroupForm });

    case CLICKED_NEW_GROUP:
      var copy = clone(state);
      copy.groupForm.clickedNewGroup = true;
      return objectAssign({}, state, { groupForm: copy.groupForm });

    case CLICKED_UPDATE_GROUP:
      var copy = clone(state);
      copy.groupForm.headerName = copy.groupForm.name;
      copy.groupForm.clickedUpdateGroup = true;
      return objectAssign({}, state, { groupForm: copy.groupForm });

    case UPDATE_GROUP_SEARCH:
      return objectAssign({}, state, {
        currentGroupFilter: action.data,
      });

    default:
      return state;
  }
};

export default reducer;
